export default __webpack_public_path__ + "static/media/organic.5b125630.svg";